import { useTranslation } from 'react-i18next'
import { Link2 } from 'lucide-react'
import { Logo } from '../components/Logo'
import { useTenant } from '../context/TenantContext'

/**
 * Shown when the org only admits patients who opened their personal magic link,
 * and this browser has no valid session.
 *
 * Before this existed (2026-09-16) such a patient could fill in every step and
 * was only rejected by the API at the documents, the SMS code or the final
 * submit — the SMS step even claimed a code was on its way. Saying it up front,
 * with what to do, is the whole job of this page.
 */
export function LinkRequiredPage() {
  const { t } = useTranslation()
  const { tenant } = useTenant()
  const contactEmail = tenant?.contactEmail

  return (
    <div className="min-h-screen bg-muted flex flex-col">
      <div className="form-container flex-1">
        <div className="form-inner py-12">
          <div className="flex justify-center mb-8">
            <Logo size={150} />
          </div>

          <div className="flex justify-center mb-6">
            <span className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
              <Link2 className="w-8 h-8 text-primary" />
            </span>
          </div>

          <h1 className="text-h1 text-foreground mb-4 text-center">
            {t('linkRequired.title')}
          </h1>

          <p className="text-body text-muted-foreground mb-3 max-w-md mx-auto text-center">
            {t('linkRequired.body')}
          </p>
          <p className="text-body text-muted-foreground mb-8 max-w-md mx-auto text-center">
            {t('linkRequired.resume')}
          </p>

          {contactEmail && (
            <p className="text-small text-muted-foreground text-center">
              {t('linkRequired.noLink')}<br />
              <a href={`mailto:${contactEmail}`} className="text-primary hover:underline">
                {contactEmail}
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
